export default "__VITE_ASSET__eMFxnBA4__"